/* =========================================================
   The Story — reveal + subtle image parallax + stats count-up
   ========================================================= */

(function () {
  'use strict';

  function initStory(root) {
    if (!root || root.dataset.storyInit === 'true') return;
    root.dataset.storyInit = 'true';

    const reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- Reveal on scroll ----------
    const revealEls = root.querySelectorAll('.reveal');

    if ('IntersectionObserver' in window && revealEls.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.15,
          rootMargin: '0px 0px -60px 0px',
        }
      );
      revealEls.forEach((el) => io.observe(el));
    } else {
      revealEls.forEach((el) => el.classList.add('in'));
    }

    if (reducedMotion) return;

    // ---------- Image + blob parallax ----------
    const blob = root.querySelector('.story__blob');
    const img = root.querySelector('.story__img-el');

    if (blob || img) {
      let ticking = false;

      const updateParallax = () => {
        const rect = root.getBoundingClientRect();
        const viewportH = window.innerHeight;

        if (rect.bottom < -200 || rect.top > viewportH + 200) {
          ticking = false;
          return;
        }

        const progress = (rect.top + rect.height / 2 - viewportH / 2) / viewportH;
        const clamped = Math.max(-1, Math.min(1, progress));

        // Blob drifts in opposite direction to image for layered depth
        if (blob) {
          blob.style.translate = `${(clamped * 14).toFixed(1)}px ${(clamped * -10).toFixed(1)}px`;
        }
        if (img) {
          img.style.translate = `0 ${(clamped * 12).toFixed(1)}px`;
        }

        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      updateParallax();
    }

    // ---------- Stats count-up ----------
    const stats = root.querySelectorAll('.story__stat strong');
    stats.forEach((statEl) => {
      const valAttr = statEl.dataset.statValue || statEl.textContent.trim();
      const match = valAttr.match(/^(\D*)([\d,\.]+)(\D*)$/);
      if (!match) return;

      const prefix = match[1];
      const numStr = match[2].replace(/,/g, '');
      const target = parseFloat(numStr);
      const suffixText = match[3];
      if (isNaN(target)) return;

      const finalHTML = statEl.innerHTML;
      statEl.dataset.finalHtml = finalHTML;

      const supEl = statEl.querySelector('sup');
      const supHTML = supEl ? supEl.outerHTML : '';

      statEl.innerHTML = `${prefix}0${suffixText}${supHTML}`;

      const countIO = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateNumber(statEl, target, prefix, suffixText, supHTML, 1500);
              countIO.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );
      countIO.observe(statEl);
    });
  }

  function animateNumber(el, target, prefix, suffix, supHTML, duration) {
    const start = performance.now();
    const hasDecimal = target % 1 !== 0;

    function format(value) {
      const rounded = hasDecimal ? value.toFixed(1) : Math.round(value);
      const formatted = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${prefix}${formatted}${suffix}${supHTML}`;
    }

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutCubic(progress);
      el.innerHTML = format(target * eased);

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.innerHTML = el.dataset.finalHtml;
      }
    }

    requestAnimationFrame(tick);
  }

  function initAll() {
    document.querySelectorAll('.story[data-section-id]').forEach(initStory);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.story[data-section-id]');
    if (root) initStory(root);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.story[data-section-id]');
    if (root) root.dataset.storyInit = '';
  });
})();
